import { gql } from '@apollo/client';

export const fetchBillingAdminsForTransactionAccountPPC = gql`
  query fetchBillingAdminsForTransactionAccountPPC($id: ID!, $billingAdminOptions: BillingAdminOptions) {
    transactionAccount(id: $id) {
      id
      billingAdmins(billingAdminOptions: $billingAdminOptions) {
        disableRemoveFeature
        edges {
          node {
            email
            atlassianAccountId
            fullName
            isPartnerAdmin
            picture
          }
        }
      }
    }
  }
`;
